import { useTranslation } from 'react-i18next';
import { Badge } from './Badge';
import type { OrderStatus, PaymentStatus, ShippingStatus, DeliveryStatus } from '../../types/order';

type StatusType = OrderStatus | PaymentStatus | ShippingStatus | DeliveryStatus;

const statusVariants: Record<string, 'default' | 'success' | 'warning' | 'danger' | 'info' | 'accent'> = {
  pending: 'warning',
  processing: 'info',
  completed: 'success',
  cancelled: 'danger',
  refunded: 'default',
  failed: 'danger',
  paid: 'success',
  partially_refunded: 'warning',
  not_shipped: 'default',
  shipped: 'info',
  in_transit: 'accent',
  delivered: 'success',
  // Legacy delivery statuses
  confirming: 'warning',
  confirmed: 'info',
  delivering: 'accent',
  returned: 'danger',
};

interface StatusBadgeProps {
  status: StatusType;
  type?: 'order' | 'payment' | 'shipping';
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation();
  const variant = statusVariants[status] ?? 'default';

  return <Badge variant={variant}>{t(`orders.${status}`, status)}</Badge>;
}
